import styled from "styled-components";

export const PageContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 95%;
`;

export const Header = styled.div`
    padding-top: 15px;
    padding-left: 20px;
    padding-bottom: 10px;
    font-size: 20px;
    font-weight: bold;
    color: #616161;
    display: flex;
    flex-direction: column;
`;

export const Body = styled.div`
    margin-left: 70px;
    margin-top: 30px;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

export const DeleteAccountButton = styled.button`
    border-radius: 4px;
    border: 1px solid #d2d2d2;
    color: #616161;
    &:hover {
        transition: all 0.3s ease-in-out;
        background-color: #616161;
        color: #ededed;
        border: 1px solid #616161;
    }
`;